<template>
  <div class="specials section-pad" v-if="appImages.length">
    <div class="container">
      <h5 class="main-title text-center mb-1">{{ $t('appSlider.appPages') }}</h5>
      <div class="col-md-6 col-12 mb-3 mt-4 margin-auto">
        <p class="main-p gray-col text-center">
          {{ $t('appSlider.downloadApp') }}
        </p>
      </div>
      <section class="app-section">
        <div class="back-ph">
          <img :src="mobileBack" alt="" />
        </div>
        <div class="catogry-carousel owl-carousel">
          <div class="pad-slider">
            <swiper
              :pagination="pagination"
              :modules="modules"
              :breakpoints="{
                '1024': {
                  slidesPerView: 5,
                  spaceBetween: 20,
                },
                '767': {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                '300': {
                  slidesPerView: 1,
                  spaceBetween: 30,
                },
              }"
              :slides-per-view="2"
              :centeredSlides="true"
              :space-between="20"
              :navigation="true"
              class="mySwiper"
              :autoplay="{
                delay: 4500,
                disableOnInteraction: false,
              }"
              :loop="true"
            >
              <swiper-slide
                class="home-item"
                v-for="slider in appImages"
                :key="slider"
              >
                <img class="home-img" :src="slider.src" alt="" />
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </section>
      <div class="flex-group-me mt-4">
        <div class="downloads">
          <a target="_blank" :href="introSite.ios_app_link" >
            <img :src="appleImg" alt="googlePlay" />
          </a>
          <a target="_blank" :href="introSite.android_app_link">
            <img :src="googleImg" alt="apple" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
// Import Swiper styles
import "swiper/css";

import "swiper/css/pagination";
import "swiper/css/navigation";
// import required modules
import { Autoplay, Pagination, Navigation } from "swiper";

export default {
  props: ["appImages"  , "introSite"],
  data() {
    return {
      containerStep: require("../../assets/imgs/Group 179167.png"),
      mobileBack: require("../../assets/imgs/backsw(1).png"),
      googleImg: require("../../assets/imgs/Group 4461.png"),
      appleImg: require("../../assets/imgs/Group 4460.png"),
    };
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      pagination: {
        clickable: true,
      },

      modules: [Pagination, Autoplay, Navigation],
    };
  },
  methods: {},

  mounted() {},
};
</script>
